import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { useSelector } from 'react-redux';
import { mapFieldValues } from '../plagins/utility';
import { GlobalContext } from '../../../App';
import PaymentsManagementExample from '../../template/tableV2/PaymentsManagementExample';
import useFilteredData from '../../template/tableV2/FilterFunction';
import { createFetchDataServer } from '../../../database/fetchData';
import { formatPriceIL } from '../plagins/data/commponentOptions';

// פונקציה לחשב רוחב קומפוננטה מותאם
const calculateDynamicWidth = () => {
  const screenWidth = window.innerWidth; // רוחב המסך
  let componentWidth;

  if (screenWidth >= 1200) {
    // מסך מחשב
    componentWidth = screenWidth * 0.8; // 80%
  } else if (screenWidth >= 768) {
    // מסך טאבלט
    componentWidth = screenWidth * 0.95; // 95%
  } else {
    // מסך פלאפון
    componentWidth = screenWidth; // 100%
  }

  return Math.round(componentWidth);
};

const PurchasesHome = ({ filter = [] }) => {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsTablePurchases.data);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const [rowsPerPage, setRowsPerPage] = useState(25); // מספר רשומות להצגה בעמוד
  const [currentPage, setCurrentPage] = useState(1); // עמוד נוכחי

  // ערכי הראוטר
  const navigate = useNavigate();
  const location = useLocation();

  const { searchText, setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setBreadcrumbs, setTitle, permission } = useContext(GlobalContext);

  const myPermissions = [1];
  const tempPermission = permission === 0 || myPermissions.includes(permission);

  useEffect(() => {
    const width = calculateDynamicWidth();
    setTotalWidthContainer(width);

    // עדכון רוחב הקומפוננטה אם גודל המסך משתנה
    const handleResize = () => {
      const newWidth = calculateDynamicWidth();
      setTotalWidthContainer(newWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location.pathname]);

  useEffect(() => {
    // בדיקה אם הכתובת מסתיימת ב-'globalSearch'
    if (location.pathname.endsWith('globalSearch')) {
      setBreadcrumbs([]);
      setTitle(`חיפוש כללי`);
    } else if (location.pathname.endsWith('bookkeepingDashboard')) {
      setBreadcrumbs([]);
      setTitle(`רכישות פתוחות`);
    } else {
      setBreadcrumbs([]);
      setTitle(`רכישות`);
    }
  }, [location.pathname]);

  const mappedDatas = mapFieldValues(context?.contextPurchases, optionsFields)
      ?.map( m => { 
        return {...m, price: formatPriceIL(m?.price)}
      })

  // שימוש בפונקציה החיצונית לסינון הנתונים
  const filteredDataPurchases = useFilteredData(mappedDatas, searchText)
  
  const handleRowClick = (row) => {
    let temp = context?.contextGraves?.find((g) => g.unicId === row[0]?.graveId)?.areaGraveId;

    navigate(`/areaGrave/${temp}`, {
      state: {
        value: context?.contextAreaGraves?.find((ag) => ag.unicId === temp)
      }
    });
  };

  const onPageChange = (item) => {
    console.log(item);
  };

  const onRowsPerPageChange = (item) => {
    console.log(item);
  };

  useEffect(() => {
    async function loadTableData() {
      fetchDataServer(['purchases', 'graves'], token);
    }
    loadTableData();
  }, []);

  return (
    <>
      <PaymentsManagementExample
        columns={columns.filter((prop) => prop.show)}
        defaultRows={filteredDataPurchases}
        searchText={filteredDataPurchases}
        onRowSelect={handleRowClick}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        defaultHeight={'1000px'}
      />
    </>
  );
};

export default PurchasesHome;
